// Package imports:
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
// Component imports:
import PriceCard from '../../PriceCard/PriceCard';
import SignUpForm from '../SignUpForm/SignUpForm';
import Link from '../../../ui-elements/Link/Link';
import HeadSection from '../../../ui-elements/HeadSection/HeadSection';
// Service imports:
import { formatNumber } from '../../../services/utils';
// Type imports:
import { KeldanSubOption } from '../../../types/SignUpTypes';

interface IProps {
    subscriptionChoice?: KeldanSubOption
}

const SignUpPage: React.FC<IProps> = ({
    subscriptionChoice = 'free'
}) => {
    const price = subscriptionChoice === 'free' ? 0 : subscriptionChoice === 'premium1' ? 4900 : 8900;
    const [activeStep, setActiveStep] = useState(0);
    return (
        <div className='main KCL_sign-up-page'>
            <div className="main__inner">
                <div className="section--signup shell">
                    <HeadSection
                        title={activeStep === 0
                            ? (subscriptionChoice === 'free'
                                ? 'Aðgangur að Keldunni'
                                : 'Áskrift að Keldunni')
                            : activeStep === 1
                                ? 'Yfirfara upplýsingar'
                                : 'Velkomin/n á Kelduna'
                        }
                    />
                    <div className="section__body">
                        <div className="section__body-inner">
                            <aside className="section__aside">
                                {subscriptionChoice === 'free'
                                    ? <PriceCard
                                        className="price-card--signup"
                                        variant="tertiary"
                                        type="Frítt"
                                        price={formatNumber(price, null, 0)}
                                        priceInfo="kr. á mánuði"
                                        badge="Þitt val"
                                    >
                                        <ul className="list-option-checks">
                                            <li><FontAwesomeIcon icon={faCheck} className="icon-fa" /> Aðgangur að öllum helstu skrám samkvæmt verðskrá Keldunnar</li>
                                        </ul>
                                    </PriceCard>
                                    : subscriptionChoice === 'premium1'
                                    ? <PriceCard
                                        className="price-card--signup"
                                        showRibbon
                                        variant="primary"
                                        type="Áskrift"
                                        price={formatNumber(price, null, 0)}
                                        priceInfo="kr. á mánuði + VSK"
                                        badge="Þitt val"
                                    >
                                        <p><strong>Aðgangur fyrir 1-4 notendur</strong></p>
                                        <ul className="list-option-checks">
                                            <li><FontAwesomeIcon icon={faCheck} className="icon-fa" /> Aðgangur að öllum helstu skrám</li>
                                            <li><FontAwesomeIcon icon={faCheck} className="icon-fa" /> Ódýrari stakar skýrslur (sjá verðskrá)</li>
                                            <li><FontAwesomeIcon icon={faCheck} className="icon-fa" /> Gögn sýnileg á fyrirtækjasíðum</li>
                                            <li><FontAwesomeIcon icon={faCheck} className="icon-fa" /> Innslegnir ársreikningar</li>
                                            <li><FontAwesomeIcon icon={faCheck} className="icon-fa" /> Samanburðarskýrslur</li>
                                            <li><FontAwesomeIcon icon={faCheck} className="icon-fa" /> Fyrirtæki geta einnig sótt um aðgang að veðböndum</li>
                                            <li><FontAwesomeIcon icon={faCheck} className="icon-fa" /> Fyrirtækjavakt</li>
                                            <li><FontAwesomeIcon icon={faCheck} className="icon-fa" /> Fréttavakt</li>
                                            <li><FontAwesomeIcon icon={faCheck} className="icon-fa" /> Verðmat fyrirtækja</li>
                                        </ul>
                                    </PriceCard>
                                    : <PriceCard
                                        className="price-card--signup"
                                        showRibbon
                                        variant="primary"
                                        type="Áskrift +"
                                        price={formatNumber(price, null, 0)}
                                        priceInfo="kr. á mánuði + VSK"
                                        badge="Þitt val"
                                    >
                                        <p><strong>Aðgangur fyrir allt að 10 notendur</strong></p>
                                        <ul className="list-option-checks">
                                            <li><FontAwesomeIcon icon={faCheck} className="icon-fa" /> Aðgangur að öllum helstu skrám</li>
                                            <li><FontAwesomeIcon icon={faCheck} className="icon-fa" /> Ódýrari stakar skýrslur (sjá verðskrá)</li>
                                            <li><FontAwesomeIcon icon={faCheck} className="icon-fa" /> Gögn sýnileg á fyrirtækjasíðum</li>
                                            <li><FontAwesomeIcon icon={faCheck} className="icon-fa" /> Innslegnir ársreikningar</li>
                                            <li><FontAwesomeIcon icon={faCheck} className="icon-fa" /> Samanburðarskýrslur</li>
                                            <li><FontAwesomeIcon icon={faCheck} className="icon-fa" /> Fyrirtæki geta einnig sótt um aðgang að veðböndum</li>
                                            <li><FontAwesomeIcon icon={faCheck} className="icon-fa" /> Fyrirtækjavakt</li>
                                            <li><FontAwesomeIcon icon={faCheck} className="icon-fa" /> Fréttavakt</li>
                                            <li><FontAwesomeIcon icon={faCheck} className="icon-fa" /> Verðmat fyrirtækja</li>
                                        </ul>
                                    </PriceCard>
                                }
                                <p>Ekki rétt valið? <Link url="/Verdskra" linkSize='16'>Farðu til baka til að breyta</Link></p>
                            </aside>
                            <div className="section__content">
                                <SignUpForm
                                    subscriptionChoice={subscriptionChoice}
                                    price={price}
                                    activeStep={activeStep}
                                    setActiveStep={setActiveStep}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SignUpPage;